import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-portfolio-three-column',
  templateUrl: './portfolio-three-column.component.html',
  styleUrl: './portfolio-three-column.component.css'
})
export class PortfolioThreeColumnComponent {
  isTransparent = true;
  isMenuOpen = false;
  activeDropdown: number | null = null;

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  toggleDropdown(index: number): void {
    this.activeDropdown = this.activeDropdown === index ? null : index;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    this.activeDropdown = null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.nav-item') && !target.closest('.header-toggle')) {
      this.activeDropdown = null;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isTransparent = offset < 100;
  }

  //Header End

  //Works
  works = [
    {
      img: 'gallery-1.jpg',
      title: 'Digital Food',
      category: 'Branding'
    },
    {
      img: 'gallery-2.jpg',
      title: 'Astronaut',
      category: 'UX Design'
    },
    {
      img: 'gallery-3.jpg',
      title: 'Poster',
      category: 'Media'
    },
    {
      img: 'gallery-4.jpg',
      title: 'Blue Berry',
      category: 'Illustration, Media'
    },
    {
      img: 'gallery-5.jpg',
      title: 'Ten Branding',
      category: 'Branding, UX Design'
    },
    {
      img: 'gallery-6.jpg',
      title: 'Digi Veg',
      category: 'Branding'
    }
  ];
}
